/**
 * Deterministic “cover” styling from a game name (gradient + label text).
 * No network images — stable across reloads for the same name.
 */

const PALETTES = [
  ['#6366f1', '#8b5cf6', '#ec4899'],
  ['#0ea5e9', '#06b6d4', '#14b8a6'],
  ['#f59e0b', '#f97316', '#ef4444'],
  ['#10b981', '#22c55e', '#84cc16'],
  ['#d946ef', '#a855f7', '#6366f1'],
  ['#14b8a6', '#0ea5e9', '#6366f1'],
  ['#f43f5e', '#fb7185', '#fbbf24'],
];

function hashString(str) {
  let h = 0;
  const s = String(str || 'game');
  for (let i = 0; i < s.length; i += 1) {
    h = Math.imul(31, h) + s.charCodeAt(i);
    h |= 0;
  }
  return Math.abs(h);
}

/** First meaningful character(s) for display on the cover */
export function gameCoverLabel(name) {
  const t = String(name || '').trim();
  if (!t) return '?';
  const words = t.split(/\s+/).filter(Boolean);
  if (words.length >= 2) {
    const a = words[0][0] || '';
    const b = words[words.length - 1][0] || '';
    return (a + b).toUpperCase().slice(0, 3);
  }
  return t.slice(0, 2).toUpperCase();
}

/**
 * @returns {{ style: React.CSSProperties, label: string, paletteIndex: number }}
 */
export function gameCoverFromName(name) {
  const h = hashString(name);
  const palette = PALETTES[h % PALETTES.length];
  const label = gameCoverLabel(name);
  return {
    label,
    paletteIndex: h % PALETTES.length,
    style: {
      background: `linear-gradient(135deg, ${palette[0]} 0%, ${palette[1]} 48%, ${palette[2]} 100%)`,
    },
  };
}
